import React from "react";
import { useTranslation } from "react-i18next";

const LedgerCardTab = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="p-3">
      <div className="text-muted">{t('ledgerCardTab.contentComingSoon')}</div>
    </div>
  );
};

export default LedgerCardTab;


